const LANGS = [
  {
    value: "en",
    label: "English",
    icon: "ic_flag_en.svg",
  },
  {
    value: "id",
    label: "Bahasa Indonesia",
    icon: "ic_flag_id.svg",
  },
  {
    value: "ru",
    label: "Русский",
    icon: "ic_flag_ru.svg",
  },
  {
    value: "zh",
    label: "中文 (简体)",
    icon: "ic_flag_zh.svg",
  },
  {
    value: "ko",
    label: "한국어",
    icon: "ic_flag_ko.svg",
  },
  {
    value: "fr",
    label: "Français",
    icon: "ic_flag_fr.svg",
  },
  {
    value: "de",
    label: "Deutsch",
    icon: "ic_flag_de.svg",
  },
  {
    value: "nl",
    label: "Nederlands",
    icon: "ic_flag_nl.svg",
  },
];

export default LANGS;
